/** Alternative-name type marking a publisher's imprint (brand). */
export var IMPRINT_ALTERNATIVE_NAME_TYPE = "IMPRINT";
var SUGGESTION_LOCALE = "cs";
/**
 * Returns the distinct, non-blank names of the publisher's alternative names
 * of type IMPRINT, in their original order.
 */
export var getOwnerImprints = function (publisher) {
    var _a;
    var alternativeNames = (_a = publisher === null || publisher === void 0 ? void 0 : publisher.alternativeNames) !== null && _a !== void 0 ? _a : [];
    var seen = new Set();
    var imprints = [];
    alternativeNames.forEach(function (alternativeName) {
        var _a;
        if ((alternativeName === null || alternativeName === void 0 ? void 0 : alternativeName.type) !== IMPRINT_ALTERNATIVE_NAME_TYPE)
            return;
        var name = (_a = alternativeName.name) === null || _a === void 0 ? void 0 : _a.trim();
        if (!name || seen.has(name))
            return;
        seen.add(name);
        imprints.push(name);
    });
    return imprints;
};
/** Case-insensitive substring filter of imprint names by the typed text. */
export var filterImprints = function (imprints, query) {
    var needle = query === null || query === void 0 ? void 0 : query.trim().toLocaleLowerCase(SUGGESTION_LOCALE);
    if (!needle)
        return imprints;
    return imprints.filter(function (imprint) {
        return imprint.toLocaleLowerCase(SUGGESTION_LOCALE).includes(needle);
    });
};
